import TransactionForInvoiceDatagrid from '../EntityDatagrids/TransactionsForFundraisingDatagrid';

const FundraisingTransactionsPage = () => (<TransactionForInvoiceDatagrid />);
export default FundraisingTransactionsPage;
